export default __webpack_public_path__ + "static/media/ninetyPercentageThreshold.d02636c3.svg";